module.exports = __webpack_public_path__ + "img/arr_loud.08a0f722.svg";